import { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import { getStates } from '../../../api/services/stateService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import { getHomeDistrict, updateHomeDistrict, deleteHomeDistrict } from '../../../api/services/homeDistrictService';
import { useLocation, useParams } from 'react-router-dom';
import Select from 'react-select';
import { graySelectStyles } from '../../../common/selectStyles';

type ViewState = { message?: string; }; //Get our view state
type Params = { id: string; }; //GET params

const fetchHomeDistrict = async ({ id }: any) => await getHomeDistrict(id);
const EditHomeDistrict = () => {
  const { state } = useLocation<ViewState>();
  const { id } = useParams<Params>();
  const history = useHistory();

  // State
  const [name, setName] = useState('');
  const [visible, setVisible] = useState(false);
  const [stateId, setStateId] = useState<number>(1);
  const [city, setCity] = useState('');
  const [county, setCounty] = useState('');

  //Get Home District Data
  const districtData = useAsync({
    promiseFn: fetchHomeDistrict,
    id,
    onResolve: (r) => {
      //setDistrictId(r.data.district.districtId);
      setName(r.data.name ?? '');
      setStateId(Number(r.data.stateId ?? 0));
      setCity(r.data.city ?? '');
      setCounty(r.data.county ?? '')
    },
  }) ?? { data: {} };

  //Get the states
  const statesData = useAsync({ promiseFn: getStates });

  /**
   * Saves the home district asynchronously.
   *
   * @return {Promise<ReturnType>} The updated home district.
   */

  const saveHomeDistrict = async () => {
    return await updateHomeDistrict(Number(id), {
      name: name,
      isVisible: visible,
      stateId: stateId,
      city: city,
      county: county,
      homeDistrictId: Number(id ?? 0)
    });
  };

  /**
   * Async hook to save home district
   */
  const save = useAsync({
    deferFn: saveHomeDistrict,
    onResolve: (r) => history.push(`/admin/homeDistricts`, { message: `"${name}" saved successfully!` }),
    onReject: () => window.scrollTo(0, 0)
  });

  const handleSubmit = () => save.run();

  /**
   * Deletion code. Not used right now
   */
  const doDeleteHomeDistrict = async () => await deleteHomeDistrict(Number(id));
  const deleteHomeDistrictAsync = useAsync({
    deferFn: doDeleteHomeDistrict,
    onResolve: (r) => history.push(`/admin/homeDistricts`, { message: `"${name}" deleted successfully!` }),
    onReject: () => window.scrollTo(0, 0),
  });
  const handleDelete = (id: number) => deleteHomeDistrictAsync.run(id)

  return (
    <Fragment>
      <Layout
        isLoading={
          statesData.isPending ||
          save.isPending ||
          districtData.isPending
        }>
        <Fragment>
          <ResponseStatus state={save} />
          <div>
            <div className='grid grid-cols-6 gap-6 mb-6'>
              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='district'
                  label='Name'
                  minLength={1}
                  maxLength={150}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>

              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='city-field'
                  label='City'
                  onChange={(e) => setCity(e.target.value)}
                  value={city}
                />
              </div>
              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='county-field'
                  label='County'
                  onChange={(e) => setCounty(e.target.value)}
                  value={county}
                />
              </div>
              <div className='col-span-6 sm:col-span-6'>
                <label className='primary'>
                  State<span className='pl-1 text-red-500'>*</span>
                </label>
                <Select
                  onChange={(selected) => selected && setStateId(Number(selected.value))}
                  className='block mt-1'
                  value={statesData.data?.data.states
                    .map(s => ({ value: s.stateId, label: s.name }))
                    .find(o => o.value === stateId) || null}
                  options={statesData.data?.data.states
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(s => ({ value: s.stateId, label: s.name })) || []}
                  styles={graySelectStyles}
                />
              </div>
            </div>
          </div>

          <hr className='py-4' />

          <div className='text-right'>
            <button
              className={'float-left'}
              disabled={name.length === 0}
              onClick={handleSubmit}
            >Save Changes</button>
            {/*<button
              className={'float-left bg-black hover:bg-black'}
              onClick={() => handleDelete(Number(id))}
                  >Delete Home District</button>*/}
          </div>
        </Fragment>
      </Layout>
    </Fragment>
  );
};

export default EditHomeDistrict;
